// extracted by mini-css-extract-plugin
export default {"tapeBody":"light_tapeBody__Lrraz color_colorLightBorder__6Pa4H","overflow":"light_overflow__K5JNm color_colorLightBorder__6Pa4H color_colorLightBackground__vzlHN"};